import { Options } from 'vue-class-component';
import ThermoGeneralStep from '../ThermoGeneralStep';
import {
  getThermoPreferencesSections,
  ThermoSettingsPreference,
  loadThermoPreferencesSectionsComponents,
} from '@/core/utils/thermo-preferences.utils';

@Options({
  name: 'StepThermostatPreferences',
  components: loadThermoPreferencesSectionsComponents(),
})
export default class StepThermostatPreferences extends ThermoGeneralStep {
  currentPreference: ThermoSettingsPreference | null = null;

  get preferencesList(): ThermoSettingsPreference[] {
    return getThermoPreferencesSections();
  }

  get preferenceComponent() {
    if (this.currentPreference) {
      return `Preference${this.currentPreference.value}`;
    }

    return null;
  }

  showSettings(p: ThermoSettingsPreference) {
    this.currentPreference = p;
  }
}
